import { Outlet } from 'react-router';
import ToastContainer from '../components/ToastContainer';

export default function _app() {
  return (
    <>
      <Outlet />
      <ToastContainer />
    </>
  );
}
